import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import BackgroundElements from './background-elements/BackgroundElements';

const HomeScreen = ({ onReviewClick, onAllBrandsClick, onAuthorityClick }) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/26ua-lm-lfc-p/bg.png')})`
        }}
      >
        <BackgroundElements />
        <img
          className={styles.staticFlower}
          src={getImageFromS3('images/26ua-kv3/static-flower.png')}
          alt="staticFlower"
        />
        <img
          className={styles.logo}
          src={getImageFromS3('images/26ua-lm-lfc-p/logo.png')}
          alt="logo"
        />
        <h1>L&M First Cut Pink</h1>
        <img
          className={styles.packs}
          src={getImageFromS3('images/26ua-lm-lfc-p/pack.png')}
          alt="packs"
        />
        <div className={styles.buttonContainer}>
          <button className={styles.reviewButton} onClick={onReviewClick}>
            <p>Залишити відгук про продукт</p>
            <img
              src={getImageFromS3('images/26ua-lm-lfc-p/glass.png')}
              alt="glass"
            />
          </button>
          <button className={styles.rangeButton} onClick={onAllBrandsClick}>
            <p>Повний асортимент</p>
          </button>
        </div>
        <div className={styles.formatContainer}>
          <h2>Формат</h2>
          <h3>
            100 Super Slims
            <br />
            ("100 супер слімc")
          </h3>
          <img
            src={getImageFromS3('images/26ua-lm-lfc-p/format.png')}
            alt="format"
          />
        </div>
        <div className={styles.tobaccoContainer}>
          <h2>
            <b>Якісна</b> тютюнова
            <br /> суміш
          </h2>
          <img
            src={getImageFromS3('images/26ua-lm-lfc-p/tobacco.png')}
            alt="tobacco"
          />
        </div>
        <div className={styles.filterContainer}>
          <h2>
            <b>Класичний</b>
            <br /> ацетатний фільтр
          </h2>
          <h3>з високоякісної целюлози</h3>
          <img
            src={getImageFromS3('images/26ua-lm-lfc-p/filter.png')}
            alt="filter"
          />
        </div>
        <div className={styles.differenceContainer} onClick={onAuthorityClick}>
          <img
            src={getImageFromS3('images/26ua-lm-lfc-p/difference.png')}
            alt="difference"
          />
          <p>
            Як <b>відрізнити оригінал</b> сигарет від підробки
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
          >
            <circle cx="13.5" cy="13.5" r="13" stroke="white" />
            <mask id="path-2-inside-1_428_16638" fill="white">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6328 7.25853L18.7199 12.8759C19.0934 13.2206 19.0934 13.7794 18.7199 14.1241L12.6328 19.7415C12.2593 20.0862 11.6537 20.0862 11.2801 19.7415C10.9066 19.3968 10.9066 18.8379 11.2801 18.4932L16.6908 13.5L11.2801 8.50682C10.9066 8.16212 10.9066 7.60324 11.2801 7.25853C11.6537 6.91382 12.2593 6.91382 12.6328 7.25853Z"
              />
            </mask>
            <path
              d="M18.7199 12.8759L16.6853 15.0805L16.6853 15.0805L18.7199 12.8759ZM12.6328 7.25853L10.5983 9.46321L10.5983 9.46321L12.6328 7.25853ZM18.7199 14.1241L16.6853 11.9195L16.6853 11.9195L18.7199 14.1241ZM12.6328 19.7415L10.5983 17.5368L10.5983 17.5368L12.6328 19.7415ZM11.2801 18.4932L9.2456 16.2885L9.2456 16.2885L11.2801 18.4932ZM16.6908 13.5L18.7254 15.7047L21.1144 13.5L18.7254 11.2953L16.6908 13.5ZM18.7199 12.8759L20.7544 10.6712L14.6674 5.05385L12.6328 7.25853L10.5983 9.46321L16.6853 15.0805L18.7199 12.8759ZM18.7199 14.1241L20.7544 16.3288C22.4152 14.7962 22.4152 12.2038 20.7544 10.6712L18.7199 12.8759L16.6853 15.0805C15.7716 14.2373 15.7716 12.7627 16.6853 11.9195L18.7199 14.1241ZM12.6328 19.7415L14.6674 21.9461L20.7544 16.3288L18.7199 14.1241L16.6853 11.9195L10.5983 17.5368L12.6328 19.7415ZM11.2801 19.7415L9.2456 21.9461C10.7682 23.3513 13.1447 23.3513 14.6674 21.9461L12.6328 19.7415L10.5983 17.5368C11.3738 16.8211 12.5391 16.8211 13.3147 17.5368L11.2801 19.7415ZM11.2801 18.4932L9.2456 16.2885C7.5848 17.8211 7.5848 20.4135 9.2456 21.9461L11.2801 19.7415L13.3147 17.5368C14.2284 18.38 14.2284 19.8546 13.3147 20.6979L11.2801 18.4932ZM16.6908 13.5L14.6563 11.2953L9.2456 16.2885L11.2801 18.4932L13.3147 20.6979L18.7254 15.7047L16.6908 13.5ZM11.2801 8.50682L9.2456 10.7115L14.6563 15.7047L16.6908 13.5L18.7254 11.2953L13.3147 6.30215L11.2801 8.50682ZM11.2801 7.25853L9.2456 5.05385C7.5848 6.58649 7.5848 9.17886 9.2456 10.7115L11.2801 8.50682L13.3147 6.30215C14.2284 7.14537 14.2284 8.61998 13.3147 9.46321L11.2801 7.25853ZM12.6328 7.25853L14.6674 5.05385C13.1447 3.64871 10.7682 3.64872 9.2456 5.05385L11.2801 7.25853L13.3147 9.46321C12.5391 10.1789 11.3738 10.1789 10.5983 9.46321L12.6328 7.25853Z"
              fill="white"
              mask="url(#path-2-inside-1_428_16638)"
            />
          </svg>
        </div>
        <div className={styles.quizContainer}>
          <div className={styles.quizContent}>
            <h3>
              <b>Актуальний асортимент</b> можна знайти на офіційних онлайн
              сервісах або у роздрібних точках продажу в твоєму місті
            </h3>
            <button
              className={styles.quizButton}
              onClick={() =>
                window.open(
                  'https://rozetka.com.ua/ua/lm-4823003217185/p611410244/',
                  '_blank'
                )
              }
            >
              <p>Rozetka</p>
              <img
                src={getImageFromS3('images/26ua-lm-lfc-p/quiz-glass.png')}
                alt="quiz-glass"
              />
            </button>
            <button
              style={{ marginTop: 60 }}
              className={styles.quizButton}
              onClick={() =>
                window.open(
                  'https://cig-poshta.in.ua/product-tag/lm-superslims-fc/',
                  '_blank'
                )
              }
            >
              <p>Cig-Poshta</p>
              <img
                src={getImageFromS3('images/26ua-lm-lfc-p/quiz-glass.png')}
                alt="quiz-glass"
              />
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні
        <br />
        захворювання та
        <br />
        залежність Дана
        <br />
        інформація про
        <br />
        продукт надається
        <br />
        відповідно до статті 15
        <br />
        Закону України «Про
        <br />
        захист прав
        <br />
        споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
